import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import pencil from "assets/images/pencil.png";
import { ErrorHelperText } from "components/ErrorHelperText";

type Props = {
  title: string;
  isEditModal?: boolean;
  isErrorVisible?: boolean;
  isAddLogic?: boolean;
  error?: string;
};

export const ModalHeader = ({
  isEditModal,
  title,
  isErrorVisible,
  error,
  isAddLogic = true,
}: Props) => {
  const theme = useTheme();
  return (
    <>
      <Box
        sx={{
          pl: "40px",
          position: "sticky",
          top: 0,
          zIndex: 2,
          width: "100%",
          minHeight: "50px",
          display: "flex",
          alignItems: "center",
          backgroundColor: theme.palette.secondary.main,
        }}
      >
        {isEditModal ? (
          <img
            src={pencil}
            alt="edit"
            style={{
              marginRight: "15px",
            }}
          />
        ) : isAddLogic ? (
          <Typography
            sx={{
              mr: "15px",
              color: "white",
              fontSize: "24px",
              fontWeight: 600,
            }}
          >
            +
          </Typography>
        ) : null}
        <Typography
          sx={{ color: "white", fontSize: "14px", fontWeight: "600" }}
        >
          {title}
        </Typography>
      </Box>
      {isErrorVisible && error && (
        <Box
          sx={{
            pl: "40px",
            width: "100%",
            height: "40px",
            display: "flex",
            alignItems: "center",
            backgroundColor: theme.palette.primary.light,
          }}
        >
          <ErrorHelperText isVisible={isErrorVisible} value={error} />
        </Box>
      )}
    </>
  );
};
